import { EnvironmentOptionsEnum } from "src/app/Enums/EnvironmentOptionsEnum";
import { TaxRegimeEnum } from "src/app/Enums/TaxRegimeEnum";
import { AccountantNfce } from "src/app/models/NfceWizard/Accountant";
import { CompanyNfce } from "src/app/models/NfceWizard/Company";
import { NfceInformation } from "src/app/models/NfceWizard/NfceInformation";
import { TaxRegime } from "src/app/models/NfceWizard/TaxRegime.model";

export class Nfce {
    private taxRegime: TaxRegime | null = null;
    private company: CompanyNfce | null = null;
    private accountants: AccountantNfce[] = [];
    //sentCertificateA1?: Date;
    private certificateA1ValidUntil: Date | null = null;
    private nfceInformation: NfceInformation | null = null;

    constructor(nfce?: Nfce | null) {
        if (!nfce) return;

        this.taxRegime = nfce.taxRegime;
        this.company = nfce.company;
        this.accountants = nfce.accountants ?? [];
        this.certificateA1ValidUntil = nfce.certificateA1ValidUntil ? 
            new Date(nfce.certificateA1ValidUntil) : null;
        this.nfceInformation = nfce.nfceInformation;
    }

    public SetTaxRegime(taxRegime?: TaxRegime | null) {
        if (taxRegime == null) return;
        if (taxRegime.taxRegimeId == TaxRegimeEnum.MEI) {
            this.SetTaxRegimeMEI()
        } else {
            this.SetTaxRegimeSimplesNacional(taxRegime.taxRegimeId)
        }
    }
    //Path 1
    public SetTaxRegimeMEI() {
        this.taxRegime = {
            taxRegimeId: TaxRegimeEnum.MEI,
            CRT: 4
        }
    }
    public SetTaxRegimeSimplesNacional(option: 1 | 2) {
        this.taxRegime = {
            taxRegimeId: TaxRegimeEnum.SimplesNacional,
            CRT: option
        }
    }
    public GetTaxRegime(): TaxRegime | null {
        return this.taxRegime;
    }

    //Path 2
    public SetCompanyData(company?: CompanyNfce | null) {
        if (company) {
            this.company = company;
        }
    }
    public GetCompanyData(): CompanyNfce | null {
        return this.company;
    }

    public SetAccountantData(accountant?: AccountantNfce | null) {
        if (accountant == null) return;
        this.accountants.push(accountant);
    }

    public GetAccountantsData(): AccountantNfce[] {
        return this.accountants;
    }    

    public GetAccountantByEntity(accountant: AccountantNfce): AccountantNfce | null {
        return this.accountants.find(a => a === accountant) ?? null;
    }

    //Path 3
    public SetCompanyCertificateA1(sent: Date | null) {
        if (sent)
            this.certificateA1ValidUntil = sent;
    }
    public GetCompanyCertificateA1(): Date | null {
        return this.certificateA1ValidUntil;
    }

    //Path 4
    public SetCompanyNfceInformation(nfceInformation: NfceInformation | null) {
        if (nfceInformation)
            this.nfceInformation = nfceInformation;
    }
    public GetCompanyNfceInformation(): NfceInformation | null {
        return this.nfceInformation;
    }

    public removeAccountant(accountantEmail: string) {
        this.accountants = this.accountants.filter(a => a.email !== accountantEmail);
    }

    public CleanClass() {
        this.taxRegime = null;
        this.company = null;
        this.accountants = [];
        this.certificateA1ValidUntil = null;
        this.nfceInformation = {
            cscId: 0,
            csc: "",
            serie: 0,
            numerationNfce: 0,
            environment: EnvironmentOptionsEnum.Production
        }
    }
}

